import { initialState } from "./state";


export const setPosts = (state, payload) => {
  state.posts = payload;
};

export const setPost = (state, payload) => {
  state.post = payload;
};

export const resetPost = (state) => {
  state.post = {};
};

export const reset = (state) => {
  const s = initialState();

  Object.keys(s).forEach((key) => {
    state[key] = s[key];
  });
};
